/* RASVELLÈ hero crossfade timer. Pairs with rasvelle-hero.css.
   Only activates on a Hero instance with exactly 2 image media items;
   does nothing on single-image or video heroes.
   Re-initializes safely when Shopify's Theme Editor swaps section HTML
   via the Section Rendering API (shopify:section:load), and guards
   against double-initializing the same DOM node. */
(function () {
  "use strict";

  var CROSSFADE_INTERVAL_MS = 6000;
  var INIT_ATTR = "data-rasvelle-hero-initialized";
  var intervalsByGrid = new WeakMap();

  function initHeroCrossfade(grid) {
    if (grid.getAttribute(INIT_ATTR) === "true") return; // already running

    var slides = grid.querySelectorAll(
      ":scope > .hero__media-wrapper, :scope > picture.hero__media"
    );
    if (slides.length < 2) return; // nothing to crossfade

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return; // stay on first slide, no auto-advance
    }

    var activeIndex = 0;
    var intervalId = setInterval(function () {
      slides[activeIndex].style.opacity = "0";
      activeIndex = (activeIndex + 1) % slides.length;
      slides[activeIndex].style.opacity = "1";
    }, CROSSFADE_INTERVAL_MS);

    grid.setAttribute(INIT_ATTR, "true");
    intervalsByGrid.set(grid, intervalId);
  }

  function teardownHeroCrossfade(grid) {
    var intervalId = intervalsByGrid.get(grid);
    if (intervalId) {
      clearInterval(intervalId);
      intervalsByGrid.delete(grid);
    }
    grid.removeAttribute(INIT_ATTR);
  }

  function initAll(root) {
    root.querySelectorAll(".hero__media-grid").forEach(initHeroCrossfade);
  }

  // Normal storefront + first paint in the Theme Editor
  initAll(document);

  // Theme Editor: re-init when a section's HTML is swapped in via the
  // Section Rendering API (fires on every settings change while customizing)
  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });

  // Theme Editor: clean up the old interval when a section is removed/replaced,
  // so edits don't silently accumulate orphaned timers
  document.addEventListener("shopify:section:unload", function (event) {
    event.target.querySelectorAll(".hero__media-grid").forEach(teardownHeroCrossfade);
  });
})();